import { render, staticRenderFns } from "./editGovernmentMember.vue?vue&type=template&id=d323c302&scoped=true&"
import script from "./editGovernmentMember.vue?vue&type=script&lang=js&"
export * from "./editGovernmentMember.vue?vue&type=script&lang=js&"
import style0 from "./editGovernmentMember.vue?vue&type=style&index=0&id=d323c302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d323c302",
  null
  
)

export default component.exports